import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import employeeReducer from "./slices/employeeSlice";
import feesReducer from "./slices/feesSlice";
import schoolProfileReducer from "./slices/schoolProfileSlice";
import studentReducer from "./slices/studentSlice";
import uiReducer from "./slices/uiSlice";
import notificationReducer from "./slices/notificationSlice";

export const store = configureStore({
  reducer: {
    employees: employeeReducer,
    students: studentReducer,
    auth: authReducer,
    ui: uiReducer,
    fees: feesReducer,
    schoolProfile: schoolProfileReducer,
    notifications: notificationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

// Export for use in components
export default store;
